import { Component, OnInit, ElementRef, Renderer2, PLATFORM_ID, Inject } from "@angular/core";
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { CookieService } from "ngx-cookie-service";
import { ToasterService } from "../services/toaster.service";
import { JsonLdService } from "../services/json-ld.service";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-documentation",
  templateUrl: "./documentation.component.html",
  styleUrls: ["./documentation.component.css"],
  imports: [RouterModule, RouterOutlet]
})
export class DocumentationComponent implements OnInit {
  isUserLoggedIn: boolean = false;
  userDetail: any;
  isBrowser: boolean;

  constructor(
    private activeRoute: ActivatedRoute,
    private auth: AuthService,
    private toaster: ToasterService,
    private cookieService: CookieService,
    private jsonLdService: JsonLdService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    activeRoute.data.subscribe((data: any) => {
      this.userDetail = data.profileDetails;
    });
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    this.auth.checkLogin();
    this.auth.isUserLoggedIn.subscribe((val) => {
      if (val) {
        this.isUserLoggedIn = val;
        this.auth.getUserProfile().subscribe(
          (res: any) => {
            this.userDetail = res.data;
            localStorage.setItem("uuid", res.data.uuid);
            if (isPlatformBrowser(this.platformId)) {
              sessionStorage.setItem("key", res.data.uuid);
            }
            const dateNow = new Date();
            dateNow.setMonth(dateNow.getMonth() + 6);
            this.cookieService.set("_khuuid", res.data.uuid, { expires: dateNow, path: "/" });
          },
          (err) => {
            this.toaster.show("error", "Check it out!", "Error in getting user");
          }
        );
      } else {
        this.userDetail = [];
      }
    });
    this.setupMobileNavigation();
  }

  private setupMobileNavigation() {
    const topicLinks = this.elementRef.nativeElement.querySelectorAll('.topics-bullets > li > a');
    const collapseElement = this.elementRef.nativeElement.querySelector('#navbarNav');

    topicLinks.forEach((link: HTMLElement) => {
      this.renderer.listen(link, 'click', () => {
        if (collapseElement && collapseElement.classList.contains('show')) {
          // Use Bootstrap 5 Collapse API
          const bsCollapse = new (window as any).bootstrap.Collapse(collapseElement, {
            hide: true
          });
          bsCollapse.hide();
        }
      });
    });
  }

  logout() {
    this.auth.logout().subscribe(
      (res: any) => {
        if (res.status === 200) {
          localStorage.removeItem("access_token");
          // this.cookieService.deleteAll();
          this.auth.checkLogin();
          this.auth.isUserLoggedIn.subscribe((val) => {
            this.isUserLoggedIn = val;
          });
          if ('KudosHub' in window && typeof window.KudosHub === 'function') {
            window.KudosHub('shutdown', {
              appId: "",
              email: "",
              name: "",
              created_at: 0
            });
          } else {
            console.log('KudosHub is not defined on the window object.');
          }
        }
      },
      (err: any) => {
        if (err.status === 401) {
          this.toaster.show(
            "error",
            "Check it out!",
            "There was a problem logging you out"
          );
        }
      }
    );
  }
}
